/**
 * 获取访问来源
 */

export default function (Vue) {
  Vue.mixin({
    created () {
      this.$from = function () {
        let cacheData = this.$parseParams(this.$cache.getCache())
        return {
          isNormal: cacheData.identity === '0',
          isInner: cacheData.identity === '1',
          isOuter: cacheData.identity === '2'
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/appfrom.js